export default () => {
    const anchors = document.querySelectorAll('[data-anchor]');

    if(!anchors.length) {
        return;
    }

    const getNavOffset = () => {
        const element = document.querySelector('.dynamic-hero-bottom');
    
        if (element) {
            return element.clientHeight || 0;
        } else {
            return 0;
        }
    };

    const scrollToElement = (element) => {
        const {top} = element.getBoundingClientRect() ;
        const scrollTo = top - getNavOffset();
        window.scrollBy(0, scrollTo);
    }

    const anchorHandler = (e) => {
        e.preventDefault();
        const {target} = e;

        const anchor = target.closest("a")?.getAttribute('href').replace('#', ''); 
        if (!anchor) {
            return;
        }
        
        const item = document.getElementById(anchor)

        if (!item) {
            return;
        }

        const list = target.closest('ul');
        const items = list.querySelectorAll('li');
        items.forEach(item => item.classList.remove('active'));
        target.closest('li').classList.add('active');

        scrollToElement(item);
    }
    
    anchors.forEach(anchor => anchor.addEventListener('click', anchorHandler));

    // Observer

    const anchorsObjects = Array.from(anchors).map(anchor => {
        const target = anchor.hash?.replace('#', '');
        return document.getElementById(target);
    }).filter(anchor => anchor);

    if(!anchorsObjects.length) {
        return;
    }

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            const {target} = entry;
            const anchor = document.querySelector(`[data-anchor][href="#${target.id}"]`);
            const item = anchor?.closest('li');

            const action = entry.isIntersecting ? 'add' : 'remove';
            item?.classList[action]('active');
        })
    }, {
        rootMargin: '-50% 0px -50% 0px',
    });

    anchorsObjects.forEach(anchor => observer.observe(anchor));
}
